module.exports = __webpack_public_path__ + "img/minoxidil.5e5345d0.png";